import tableStore from './table'

const comsWeaTableStore = new tableStore();

export default {
	comsWeaTableStore,
}


// WEBPACK FOOTER //
// ./comMobx/wea-table/stores/index.js